<template>
  <div class="attr-prod-photo-wrapper">
    <div class="attr-prod-photo-in" v-if="mainImage">
      <a :href="mainImage['large']" class="image-popup-vertical-fit">
       <div class="thumbnail_container">
         <div class="thumbnail">
            <img :src="mainImage['medium']" alt="" class="imagepop"/>
         </div>
       </div>
      </a>
    </div>

    <div class="p-attr-photo-thumb-nav prod-gallery-row" v-if="galleryImages.length > 1">
      <div class="attr-photo-thumb-col" v-for="(navigationThumbs, index) in galleryImagesSorted" :key="index">
       <div class="attr-photo-thumb-pad">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="navigationThumbs['small']"
              @click="mainImage = navigationThumbs"
              :style="(mainImage === navigationThumbs) ? 'border: 2px solid #cccccc' : ''"
              :alt="productCodeId"/>
            </div>
          </div>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'

export default {
  name: 'AdvProductGallery',
  props: {
    productId: {
      type: Number
    },
    mainImageFirst: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [productMixin],
  data () {
    return {
      productCodeId: null,
      mainImage: null,
      galleryImages: [{
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      }]
    }
  },
  computed: {
    selectedAttributeId () {
      return store.getters.getSelectedAttributeId
    },
    selectedProductCodeId () {
      return store.getters.getSelectedProductCodeId
    },
    galleryImagesSorted () {
      if (!this.mainImageFirst) {
        return this.galleryImages
      }
      const images = this.galleryImages
      return images.sort(function (a, b) { return a.is_main === '1' ? -1 : b.is_main === '1' ? 1 : 0 })
    }
  },
  watch: {
    selectedProductCodeId (val) {
      this.productCodeId = val
      this.setUpGalleryUpdate()
    },
    selectedAttributeId (attributeId) {
      const productCode = this.productData.productCodes.find(item => item.productCodeAttributes.includes(attributeId))
      this.setUpGalleryUpdate(productCode.productCodeId)
    }
  },
  mounted () {
    this.setProductCodeId()
    this.setUpGalleryUpdate()
  },
  methods: {
    setUpGalleryUpdate (codeId = null) {
      this.productCodeImages(codeId)
      this.setMainImage()
    },
    setProductCodeId () {
      if (this.selectedProductCodeId) {
        this.productCodeId = this.selectedProductCodeId
      } else {
        this.productCodeId = parseInt(Object.keys(this.productData.images)[0])
      }
    },
    productCodeImages (codeId = null) {
      if (!(codeId === null)) {
        this.galleryImages = this.productData.images[parseInt(codeId)]
      } else if (!(this.productCodeId === null)) {
        this.galleryImages = this.productData.images[this.productCodeId]
      }
    },
    setMainImage () {
      this.mainImage = this.galleryImages.find(image => image.is_main === '1')
    }
  }
}
</script>
